export var createEncodingError = function createEncodingError() {
  return new DOMException('', 'EncodingError');
};